export default from './Kasumikalk';
export {default as store} from './KasumikalkStore';


// WEBPACK FOOTER //
// ./src/views/Kasumikalk/index.js